import keyMirror from 'keymirror';

export default keyMirror({
  GENERIC_ERROR: null,
});
